(() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function alignHeroSplit(hero) {
    const target = hero.querySelector('[data-split-target]');
    if (!target) return;

    const heroBox = hero.getBoundingClientRect();
    const targetBox = target.getBoundingClientRect();
    if (!heroBox.width || !heroBox.height) return;

    const targetX = ((targetBox.left + targetBox.width / 2 - heroBox.left) / heroBox.width) * 100;
    const targetY = (targetBox.top + targetBox.height / 2 - heroBox.top) / heroBox.height;
    const travel = window.innerWidth < 750 ? 24 : 30;
    const top = clamp(targetX - travel * targetY, 8, 72);
    const bottom = clamp(targetX + travel * (1 - targetY), 28, 92);

    hero.style.setProperty('--split-top', `${top}%`);
    hero.style.setProperty('--split-bottom', `${bottom}%`);
  }

  function alignAllHeroSplits() {
    document.querySelectorAll('[data-split-hero]').forEach(alignHeroSplit);
  }

  function initMenu() {
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const header = button.closest('[data-site-header]');
        const isOpen = header.classList.toggle('menu-open');
        button.setAttribute('aria-expanded', String(isOpen));
        document.body.classList.toggle('menu-is-open', isOpen);
      });
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;

      carousel.querySelectorAll('[data-carousel-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.carouselDirection === 'next' ? 1 : -1;
          const card = track.querySelector('.product-card');
          const distance = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        });
      });
    });
  }

  function initProductForms() {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const select = root.querySelector('[data-variant-select]');
      const input = root.querySelector('[data-variant-id]');
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      const addButton = root.querySelector('[data-add-to-cart]');
      if (!select || !input) return;

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        input.value = option.value;
        if (price) price.textContent = option.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice || '';
          comparePrice.hidden = !option.dataset.comparePrice;
        }
        if (addButton) {
          const available = option.dataset.available === 'true';
          addButton.disabled = !available;
          addButton.textContent = available ? addButton.dataset.availableText : addButton.dataset.soldOutText;
        }
      });
    });
  }

  function initQuantityControls() {
    document.querySelectorAll('[data-quantity-control]').forEach((control) => {
      const input = control.querySelector('input[type="number"]');
      if (!input) return;
      control.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const step = button.dataset.quantityChange === 'increase' ? 1 : -1;
          input.value = Math.max(Number(input.min) || 0, Number(input.value) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function init() {
    initMenu();
    initCarousels();
    initProductForms();
    initQuantityControls();
    alignAllHeroSplits();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', alignAllHeroSplits);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignAllHeroSplits);
})();
